<template>
    <div class="w-full">
        <div class="p-4">
            <CorrectIncorrectIcon :is-correct="true" />
            <span>{{ question.options.number }}</span>
            <span class="text-gray-600 text-sm ml-2">({{ question.options.tolerance }})</span>
        </div>
    </div>
</template>

<script>
import CorrectIncorrectIcon from '@/components/Quiz/CorrectIncorrectIcon.vue';

export default {
    name: 'QuestionMathNumberWithToleranceViewOnly',
    components: {
        CorrectIncorrectIcon,
    },
    props: {
        question: {
            required: true,
        },
    },
};
</script>
